import {
  RECEIVE_SALESREP,
  RECEIVING_SALESREP,
  RECEIVE_SALESREP_METADATA,
  SAVING_SALESREP,
  UPDATING_SALESREP,
  DELETE_SALESREP,
  DELETING_SALESREP,
  RESET_SALESREP_META,
  CLEAR_SALESREP_STATE,
  CLEAR_STATE,
  INCREMENT_SALESREP_COUNT,
  SET_ALL_SALESREP_LOADED
} from '@/store/mutationTypes'
import {
  receiveData,
  deleteData,
  increment,
  receiveMetadata,
  resetMetadata,
  clearLocalState,
  clearState
} from '@/store/modules/helpers/mutationHelpers'

const state = {
  data: {},
  cache: {},
  count: null,
  shown: null,
  next: null,
  previous: null,
  currentPage: 1,
  saving: false,
  receivingData: false,
  updating: null,
  deleting: false,
  allSalesrepsLoaded: false
}

const actions = {
  setSalesrepPreloadStatus (store, payload) {
    this.commit(SET_ALL_SALESREP_LOADED, payload)
  },
  clearSalesrepState (store, clearCache = false) {
    this.commit(CLEAR_SALESREP_STATE, clearCache)
  }
}

const getters = {
  getSalesrep: (state) => {
    return state.data ? Object.values(state.data).map(v => Object.assign({}, v)) : []
  },
  getAllSalesrep: (state) => {
    return state.cache ? Object.values(state.cache).map(v => Object.assign({}, v)) : []
  },
  getSalesrepMetadata: (state) => {
    const { shown, count } = state
    if (!shown) return { count: 0, shown: 0 }
    return { count, shown }
  },
  getSalesrepById: (state, rootState) => (id) => {
    if (state.data && state.data[id]) {
      return state.data[id]
    } else if (state.cache && state.cache[id]) {
      return state.cache[id]
    } else {
      return {}
    }
  },
  getDefaultSalesrep: (state) => {
    return Object.values(state.cache).find(v => v.active) || {}
  },
  getSalesrepFetchStatus: (state) => {
    return state.receivingData
  },
  getSalesrepSaveStatus: (state) => {
    return state.saving
  },
  getSalesrepUpdateStatus: (state) => {
    return state.updating
  },
  getSalesrepDeleteStatus: (state) => {
    return state.deleting
  }
}

const mutations = {
  [RECEIVE_SALESREP] (state, results) {
    receiveData(state, results)
  },
  [RECEIVING_SALESREP] (state, payload) {
    state.receivingData = payload
  },
  [SAVING_SALESREP] (state, payload) {
    state.saving = payload
  },
  [UPDATING_SALESREP] (state, payload) {
    state.updating = payload
  },
  [DELETE_SALESREP] (state, payload) {
    deleteData(state, payload)
  },
  [DELETING_SALESREP] (state, payload) {
    state.deleting = payload
  },
  [INCREMENT_SALESREP_COUNT] (state, payload) {
    increment(state, payload)
  },
  [RECEIVE_SALESREP_METADATA] (state, payload) {
    receiveMetadata(state, payload)
  },
  [CLEAR_SALESREP_STATE] (state, payload) {
    clearLocalState(state, payload)
  },
  [RESET_SALESREP_META] (state) {
    resetMetadata(state)
  },
  [CLEAR_STATE] (state) {
    clearState(state)
  },
  [SET_ALL_SALESREP_LOADED] (state, payload) {
    state.allSalesrepLoaded = payload
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/salesrep.js